// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  GoogleAuthProvider,
} from "firebase/auth";
import {
  getFirestore
} from "firebase/firestore";
import {
  getMessaging,
} from "firebase/messaging";

// ==============================
// 🔥 FIREBASE CONFIG
// ==============================
const firebaseConfig = {
  apiKey: "AIzaSyAD-iS1ezpp0QpXc-1imgC8LaxTSFp7ftc",
  authDomain: "nukkad-edc40.firebaseapp.com",
  projectId: "nukkad-edc40",
  storageBucket: "nukkad-edc40.firebasestorage.app",
  messagingSenderId: "650888533807",
  appId: "1:650888533807:web:bf112ec75804139fdbb3da",
};

// ==============================
// 🔥 INIT
// ==============================
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// ==============================
// 🔔 FCM MESSAGING
// ==============================
export const messaging = getMessaging(app);

// request permission (optional helper)
export const requestFcmPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("FCM Permission DENIED");
      return null;
    }
    return permission;
  } catch (err) {
    console.error("FCM permission error:", err);
    return null;
  }
};

// listener helper
export const listenForegroundMessages = (callback) => {
  try {
    import("firebase/messaging").then(({ onMessage }) => {
      onMessage(messaging, callback);
    });
  } catch (err) {
    console.error("Foreground message error:", err);
  }
};

export default app;
